import { TFunction } from 'i18next';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CommonDialog } from 'src/components/shared/dialog/CommonDialog';
import { actions, FortuneResultErrorType } from 'src/features/fortune';
import { getQueryParam } from 'src/lib/utils';

export const FortuneHomeErrorDialog: React.FC = () => {
  const { t } = useTranslation(['fortune', 'translation']);
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(actions.clearUpdateStatus());
    };
  }, [dispatch]);

  const errorType = getQueryParam(location.search, 'type') as FortuneResultErrorType;

  const title = t('translation:dialog_error');
  const description = errorType ? getDescription(errorType, t) : '';
  return <CommonDialog title={title} description={description} />;
};

function getDescription(type: FortuneResultErrorType, t: TFunction) {
  switch (type) {
    case 'have-already-got-point':
      return t('error_already_got_point');
    case 'invalid-date':
      return t('error_failed_to_get_point');
    case 'unstable-network':
      return t('translation:error_unstable_network');
    default:
      return t('translation:error_unknown_status');
  }
}
